import { create } from "zustand";
import { SystemInfo } from "~/types/system";

interface SystemState {
    system: SystemInfo;
    setSystem: (system: SystemInfo) => void;
    resetSystem: () => void;
}

export const useSystemStore = create<SystemState>(set => ({
    system: {} as SystemInfo,
    setSystem: system => set({ system }),
    resetSystem: () => set({ system: {} as SystemInfo }),
}));
